export const CHAT_ANSWERS = {
  // Getting Started
  "How do I add a new appointment?":
    "Go to the Appointments page (the main calendar). Click any empty time slot or the '+ New' button at the top right. Select a client, choose services, assign a staff member, pick the time, and click Save.",

  "How do I add a new client?":
    "Go to Clients in the left sidebar. Click '+ Add Client' at the top right. Enter the client's name, phone number, and email, then click Save.",

  "How do I generate an invoice?":
    "Invoices are generated automatically when you complete an appointment and record payment. Open any completed appointment, click 'Collect Payment', fill in the payment details, and the invoice is created. You can download or print it from the Invoices page.",

  // Appointments
  "How do I cancel an appointment?":
    "Click on the appointment block in the calendar. In the appointment details, click the 'Cancel' button. You will be asked to confirm. The appointment will be marked as cancelled.",

  "How do I assign staff to an appointment?":
    "When creating or editing an appointment, there is a Staff dropdown. Select the staff member from the list. You can assign multiple staff if needed.",

  "What is a walk-in appointment?":
    "A walk-in is an appointment created for a customer who arrives without a prior booking. Click '+ Walk-in' on the Appointments page, select the client (or create a new one), add services, and save. It is added instantly to the calendar.",

  "How do I reschedule an appointment?":
    "Click on the appointment in the calendar. Click 'Edit', change the date or time, and click Save. The appointment moves to the new slot.",

  // Staff
  "How do I add a new staff member?":
    "Go to the Staff page from the sidebar. Click '+ Add Staff'. Fill in their name, phone number, designation, shift, and the services they can perform. Click Save.",

  "How do I set staff working hours?":
    "Go to Staff, open a staff member's profile, and select or change their Shift from the dropdown. Shifts are configured in Settings > Shifts.",

  "How do I track staff commission?":
    "Go to Staff and open a staff member. You will see fields for Product Commission (%) and Service Commission (%). Enter the percentages and Save. Commission is automatically calculated in salary reports.",

  // Clients
  "How do I view a client's history?":
    "Go to Clients and click on a client's name. Their profile shows all past appointments, invoices, loyalty points balance, and wallet balance.",

  "How do I add loyalty points to a client?":
    "Open the client's profile from the Clients page. Scroll to the Loyalty Points section and click 'Add Points'. Enter the amount and save.",

  "How do I top up a client's wallet?":
    "Open the client's profile. Go to the Wallet section and click 'Add Amount'. Enter the amount, choose a payment method, and confirm.",

  // Inventory
  "How do I add a new product?":
    "Go to Inventory from the sidebar. Click '+ Add Product'. Fill in the product name, price, stock quantity, and category. Click Save.",

  "How do I adjust stock levels?":
    "Go to Inventory, find the product, and click to open it. Change the stock quantity field and click Save.",

  "How do I add a new service?":
    "Go to Inventory and switch to the Services tab. Click '+ Add Service'. Enter the service name, duration, and price. Click Save.",

  // Billing
  "How do I apply a discount to an invoice?":
    "When collecting payment for an appointment, there is a Discount field. Enter a percentage or flat amount before confirming the payment.",

  "How do I download an invoice?":
    "Go to the Invoices page from the sidebar. Find the invoice, click to open it, and click the Download or Print icon at the top.",

  "How do I search for an invoice?":
    "On the Invoices page, use the search bar at the top to search by client name, invoice number, or use the date filter to find invoices in a date range.",

  // Support
  "I want to raise a support ticket": "RAISE_TICKET",
  "Check my ticket status": "CHECK_TICKET",
};

export const TICKET_KEYWORDS = [
  "ticket", "raise ticket", "create ticket", "support", "problem",
  "issue", "help me", "not working", "bug", "error", "raise a ticket",
  "create a ticket", "open a ticket", "report", "complaint",
];

export const FALLBACK_ANSWER =
  "I can only help with the Aye Salon app features listed above. Please pick one of the questions below, or raise a support ticket if you need further help.";
